import { brainGameEntry, brainGameResponse } from "../types/brainGame/brainGame";
import { abstractApiCaller } from "./apiCaller";

class BrainGameApi extends abstractApiCaller {

    private sessionToken: string = '';
    private sessionEmail: string = '';

    constructor(
        sessionToken: string,
        sessionEmail: string,
    ) {
        super();
        this.sessionToken = sessionToken;
        this.sessionEmail = sessionEmail;
    }

    public async initBrainGameData(projectId:string)
    {
        const endpoint = 'braingame/init/' + projectId;

        const param = {
        };

        this.abortRequest();
        return await this.query<brainGameResponse>(endpoint, param, this.sessionToken, this.sessionEmail);
    }

    public async updateKeyEntry(projectId: string, entry: brainGameEntry)
    {
        const endpoint = 'braingame/updateKeyEntry/' + projectId;

        const param = {
            'entry': entry
        };

        this.abortRequest();
        return await this.query<brainGameResponse>(endpoint, param, this.sessionToken, this.sessionEmail);

    }
}

export { BrainGameApi };
